import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Bat extends Mob {
	constructor(sprites, infoable = true) {
		super(sprites, StandardSheetAnimations.getAnimation("bat"), Bat.WALK_STEP * Game.MULT, Bat.RADIUS);
		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;
		this.substAnimation("idle_e", 1, { row: 9, col: 0 });
		this.substAnimation("idle_w", 1, { row: 9, col: 0 });
		this.substAnimation("idle_n", 1, { row: 10, col: 0 });


		let traits = {
			clas: "enemy",
			race: "bat",
			openDoors: false,
			static: false,
			qi: BasicAI.QI_LOW,
			speed: Bat.WALK_STEP * Game.MULT,
			radius: Bat.RADIUS,
			runspeed: Bat.RUN_STEP * Game.MULT,
			timeWarns: Bat.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Bat.RADIUS = 8;
Bat.WALK_STEP = 4;
Bat.RUN_STEP = 6;
Bat.TIME_WARNS = [250, 350];